document.documentElement.classList.add('mt-js');

// Este archivo se incluye una vez por cada sección mt-*; el guard evita que
// los init se ejecuten (y enganchen sus eventos) varias veces. Sin él, un
// clic en "Add to cart" añadía el producto tantas veces como secciones había.
if (!window.__mtBooted) {
  window.__mtBooted = true;
  var mtBoot = function () {
    initReveal();
    initCountUp();
    initTilt();
    initProducto();
    initBarraMovil();
    initComparador();
    initScrollReviews();
    initZoom();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mtBoot);
  else mtBoot();
}

function initZoom() {
  var trigger = document.querySelector('[data-mt-zoom]');
  if (!trigger) return;

  // Colección de imágenes: miniaturas (alta res) o la principal
  function images() {
    var thumbs = document.querySelectorAll('[data-mt-miniatura]');
    if (thumbs.length) return Array.prototype.map.call(thumbs, function (t) { return t.getAttribute('data-mt-src'); });
    return [trigger.getAttribute('src')];
  }
  var idx = 0;

  var modal = document.createElement('div');
  modal.className = 'mt-zoom';
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.hidden = true;
  modal.innerHTML =
    '<button class="mt-zoom-close" aria-label="Close">×</button>' +
    '<button class="mt-zoom-nav mt-zoom-prev" aria-label="Previous">‹</button>' +
    '<img class="mt-zoom-img" alt="">' +
    '<button class="mt-zoom-nav mt-zoom-next" aria-label="Next">›</button>';
  document.body.appendChild(modal);

  var img = modal.querySelector('.mt-zoom-img');
  function show(i) {
    var list = images();
    idx = (i + list.length) % list.length;
    img.src = list[idx];
    modal.querySelectorAll('.mt-zoom-nav').forEach(function (n) { n.style.display = list.length > 1 ? '' : 'none'; });
  }
  function open() {
    // sincroniza con la miniatura activa si la hay
    var active = document.querySelector('[data-mt-miniatura][data-active]');
    var list = images();
    var start = 0;
    if (trigger.getAttribute('src')) { var s = trigger.getAttribute('src'); var f = list.indexOf(s); if (f > -1) start = f; }
    show(start);
    modal.hidden = false;
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
  }
  function close() {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(function () { modal.hidden = true; }, 250);
  }

  trigger.addEventListener('click', open);
  modal.querySelector('.mt-zoom-close').addEventListener('click', close);
  modal.querySelector('.mt-zoom-prev').addEventListener('click', function (e) { e.stopPropagation(); show(idx - 1); });
  modal.querySelector('.mt-zoom-next').addEventListener('click', function (e) { e.stopPropagation(); show(idx + 1); });
  modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
  document.addEventListener('keydown', function (e) {
    if (modal.hidden) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(idx - 1);
    else if (e.key === 'ArrowRight') show(idx + 1);
  });
}

function initScrollReviews() {
  var links = document.querySelectorAll('[data-mt-scroll-reviews]');
  if (!links.length) return;
  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      var target = document.querySelector('#mt-reviews');
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
}

function initComparador() {
  var wraps = document.querySelectorAll('[data-mt-comparador]');
  if (!wraps.length) return;
  wraps.forEach(function (wrap) {
    var antes = wrap.querySelector('[data-mt-comp-antes]');
    var asa = wrap.querySelector('[data-mt-comp-asa]');
    var img = wrap.querySelector('[data-mt-comp-antes-img]');
    if (!antes || !asa) return;
    var arrastrando = false;

    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      var x = clientX - rect.left;
      var pct = Math.max(0, Math.min(100, (x / rect.width) * 100));
      antes.style.width = pct + '%';
      asa.style.left = pct + '%';
      if (img) img.style.width = rect.width + 'px';
    }
    function iniciar() { arrastrando = true; }
    function parar() { arrastrando = false; }
    function mover(e) {
      if (!arrastrando) return;
      var clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPos(clientX);
    }

    wrap.addEventListener('mousedown', function (e) { iniciar(); setPos(e.clientX); });
    window.addEventListener('mouseup', parar);
    window.addEventListener('mousemove', mover);
    wrap.addEventListener('touchstart', function (e) { iniciar(); setPos(e.touches[0].clientX); }, { passive: true });
    window.addEventListener('touchend', parar);
    wrap.addEventListener('touchmove', mover, { passive: true });

    window.addEventListener('resize', function () {
      var rect = wrap.getBoundingClientRect();
      if (img) img.style.width = rect.width + 'px';
    });
    var rect0 = wrap.getBoundingClientRect();
    if (img) img.style.width = rect0.width + 'px';
  });
}

function initProducto() {
  var root = document.querySelector('[data-mt-producto]');
  if (!root) return;

  var principal = root.querySelector('[data-mt-imagen-principal]');
  // Cambia la imagen principal. Debe limpiar srcset/sizes: si no, el navegador
  // sigue usando el srcset original e ignora el nuevo .src (por eso la imagen
  // "no cambiaba" al pulsar una miniatura).
  function setPrincipal(url) {
    if (!principal || !url) return;
    principal.removeAttribute('srcset');
    principal.removeAttribute('sizes');
    principal.src = url;
  }
  root.querySelectorAll('[data-mt-miniatura]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      setPrincipal(btn.getAttribute('data-mt-src'));
      root.querySelectorAll('[data-mt-miniatura]').forEach(function (b) {
        b.style.borderColor = 'var(--mt-color-borde)';
      });
      btn.style.borderColor = 'var(--mt-color-acento)';
    });
  });

  var datos = root.querySelector('[data-mt-variantes]');
  if (!datos) return;
  var variantes;
  try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
  var selects = root.querySelectorAll('[data-mt-opcion]');
  var inputId = root.querySelector('[data-mt-variant-id]');
  var precio = root.querySelector('[data-mt-precio]');
  var precioAntes = root.querySelector('[data-mt-precio-antes]');
  var badge = root.querySelector('[data-mt-badge-oferta]');
  var ahorroBox = root.querySelector('[data-mt-ahorro]');
  var ahorroMonto = root.querySelector('[data-mt-ahorro-monto]');
  var boton = root.querySelector('[data-mt-boton-comprar]');
  var textoComprar = boton ? boton.textContent.trim() : '';

  function actualizar() {
    var elegidas = [];
    selects.forEach(function (s) { elegidas[parseInt(s.getAttribute('data-mt-opcion-index'), 10)] = s.value; });
    var v = variantes.find(function (x) {
      return x.options.every(function (opt, i) { return opt === elegidas[i]; });
    });
    if (!v) {
      if (boton) { boton.disabled = true; boton.textContent = 'No disponible'; }
      return;
    }
    if (inputId) inputId.value = v.id;
    if (precio) precio.textContent = v.price;
    if (precioAntes) {
      precioAntes.textContent = v.compare_at || '';
      precioAntes.style.display = v.compare_at ? '' : 'none';
    }
    if (badge) badge.style.display = v.compare_at ? '' : 'none';
    if (ahorroBox) {
      if (v.ahorro) {
        if (ahorroMonto) ahorroMonto.textContent = v.ahorro;
        ahorroBox.style.display = '';
      } else {
        ahorroBox.style.display = 'none';
      }
    }
    if (v.imagen) setPrincipal(v.imagen);
    if (boton) {
      boton.disabled = !v.available;
      boton.textContent = v.available ? textoComprar : (boton.getAttribute('data-mt-texto-agotado') || 'Agotado');
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });

  // Swatches de color: sincronizan con su <select> (oculto) y reusan actualizar()
  root.querySelectorAll('[data-mt-swatch]').forEach(function (sw) {
    sw.addEventListener('click', function () {
      var idx = sw.getAttribute('data-mt-opcion-index');
      var val = sw.getAttribute('data-mt-value');
      var sel = root.querySelector('select[data-mt-opcion][data-mt-opcion-index="' + idx + '"]');
      if (sel) { sel.value = val; sel.dispatchEvent(new Event('change', { bubbles: true })); }
      root.querySelectorAll('[data-mt-swatch][data-mt-opcion-index="' + idx + '"]').forEach(function (o) {
        var on = (o === sw);
        o.classList.toggle('is-active', on);
        if (o.hasAttribute('role')) o.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var label = root.querySelector('[data-mt-color-label][data-mt-opcion-index="' + idx + '"]');
      if (label) label.textContent = val;
    });
  });

  // AJAX add-to-cart: añade sin recargar, muestra estado y abre el carrito lateral
  if (boton) {
    var form = boton.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = inputId ? inputId.value : null;
        if (id) mtAddToCart(id, 1, boton);
      });
    }
  }
}

function mtOpenDrawer() {
  var d = document.querySelector('cart-drawer');
  if (!d) return;
  if (typeof d.open === 'function') { d.open(); return; }
  d.classList.remove('is-empty');
  d.classList.add('active', 'animate');
  d.setAttribute('open', '');
  document.body.classList.add('overflow-hidden');
}

function mtApplySections(sections) {
  if (!sections) return;
  // Carrito lateral
  if (sections['cart-drawer']) {
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = doc.querySelector('#CartDrawer');
    var current = document.querySelector('#CartDrawer');
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) drawerEl.classList.remove('is-empty');
  }
  // refresca la barra de envío + upsell del bundle con el carrito nuevo
  if (window.mtCartRefresh) setTimeout(window.mtCartRefresh, 60);
  // Burbuja del icono del carrito
  if (sections['cart-icon-bubble']) {
    var doc2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    var b = document.querySelector('#cart-icon-bubble');
    var freshB = doc2.querySelector('#cart-icon-bubble') || doc2.body.firstElementChild;
    if (b && freshB) b.innerHTML = freshB.innerHTML;
  }
}

function mtAddToCart(id, qty, btn) {
  var original = btn ? btn.textContent : '';
  if (btn) { btn.disabled = true; btn.classList.add('mt-btn-loading'); btn.innerHTML = '<span class="mt-spinner" aria-hidden="true"></span>'; }
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty || 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
  }).then(function (res) {
    return res.json().then(function (data) { return { ok: res.ok, data: data }; });
  }).then(function (r) {
    if (btn) btn.classList.remove('mt-btn-loading');
    if (r.ok) {
      mtApplySections(r.data.sections);
      mtOpenDrawer();
      if (btn) {
        btn.textContent = '✓ Added to cart!';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2500);
      }
    } else {
      if (btn) { btn.textContent = (r.data && r.data.description) || 'Could not add — try again'; setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2500); }
    }
  }).catch(function () {
    if (btn) { btn.classList.remove('mt-btn-loading'); btn.textContent = 'Could not add — try again'; setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2500); }
  });
}

function initBarraMovil() {
  var barra = document.querySelector('[data-mt-barra-movil]');
  var root = document.querySelector('[data-mt-producto]');
  if (!barra || !root) return;
  var botonPrincipal = root.querySelector('[data-mt-boton-comprar]');
  var botonBarra = barra.querySelector('[data-mt-barra-boton]');
  var precioBarra = barra.querySelector('[data-mt-precio-barra]');
  var precioPrincipal = root.querySelector('[data-mt-precio]');

  if (botonBarra) {
    var inputId = root.querySelector('[data-mt-variant-id]');
    botonBarra.addEventListener('click', function () {
      var id = inputId ? inputId.value : null;
      if (id) mtAddToCart(id, 1, botonBarra);
      else if (botonPrincipal) botonPrincipal.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
  if (precioBarra && precioPrincipal) {
    new MutationObserver(function () {
      precioBarra.textContent = precioPrincipal.textContent;
    }).observe(precioPrincipal, { childList: true, characterData: true, subtree: true });
  }
  if (botonPrincipal && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      barra.classList.toggle('mt-visible-barra', !entries[0].isIntersecting);
      barra.setAttribute('aria-hidden', entries[0].isIntersecting ? 'true' : 'false');
    }, { threshold: 0 }).observe(botonPrincipal);
  }
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initCountUp() {
  var els = document.querySelectorAll('[data-mt-countup]');
  if (!els.length) return;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      obs.unobserve(el);
      var target = parseFloat(el.getAttribute('data-mt-countup')) || 0;
      var suffix = el.getAttribute('data-mt-suffix') || '';
      var decimals = parseInt(el.getAttribute('data-mt-decimals') || '0', 10);
      if (prefersReduced) {
        el.textContent = target.toFixed(decimals) + suffix;
        return;
      }
      var duration = 1600;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = (target * eased).toFixed(decimals) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}

function initTilt() {
  var cards = document.querySelectorAll('[data-mt-tilt]');
  if (!cards.length) return;
  if (window.matchMedia('(pointer: coarse)').matches) return;
  cards.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = 'perspective(700px) rotateX(' + (y * -6) + 'deg) rotateY(' + (x * 6) + 'deg) translateY(-4px)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = '';
    });
  });
}
